var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
      label: 0,
      sent: function () {
        if (t[0] & 1) throw t[1];
        return t[1];
      },
      trys: [],
      ops: []
    },
    f,
    y,
    t,
    g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;
  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }
  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");
    while (g && (g = 0, op[0] && (_ = 0)), _) try {
      if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
      if (y = 0, t) op = [op[0] & 2, t.value];
      switch (op[0]) {
        case 0:
        case 1:
          t = op;
          break;
        case 4:
          _.label++;
          return {
            value: op[1],
            done: false
          };
        case 5:
          _.label++;
          y = op[1];
          op = [0];
          continue;
        case 7:
          op = _.ops.pop();
          _.trys.pop();
          continue;
        default:
          if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
            _ = 0;
            continue;
          }
          if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
            _.label = op[1];
            break;
          }
          if (op[0] === 6 && _.label < t[1]) {
            _.label = t[1];
            t = op;
            break;
          }
          if (t && _.label < t[2]) {
            _.label = t[2];
            _.ops.push(op);
            break;
          }
          if (t[2]) _.ops.pop();
          _.trys.pop();
          continue;
      }
      op = body.call(thisArg, _);
    } catch (e) {
      op = [6, e];
      y = 0;
    } finally {
      f = t = 0;
    }
    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};
var _a, _b;
import axios from 'axios';
import { substituteParams, useAPI } from '../../../state';
var STAFFING_API = '/api/orgConfig/locations/{locationId}/staffing';
var ROLES_API = '/api/orgConfig/locations/{locationId}/roles';
var ROLES_BATCH_API = '/api/orgConfig/locations/{locationId}/roles/batch';
var ROLES_COPY_FROM_API = '/api/orgConfig/locations/{locationId}/roles/copyFrom';
var STAFFING_STATUS_API = '/api/orgConfig/locations/staffing/status';
export var LocationRoleType;
(function (LocationRoleType) {
  LocationRoleType["WfmAnalyst"] = "wfm_analyst";
  LocationRoleType["QualityAssurance"] = "quality_assurance";
  LocationRoleType["Trainer"] = "trainer";
  LocationRoleType["Supervisor"] = "supervisor";
  LocationRoleType["Recruiter"] = "recruiter";
  LocationRoleType["Custom"] = "custom";
})(LocationRoleType || (LocationRoleType = {}));
export var RoleAppliesTo;
(function (RoleAppliesTo) {
  RoleAppliesTo["Queue"] = "queue";
  RoleAppliesTo["Site"] = "site";
})(RoleAppliesTo || (RoleAppliesTo = {}));
export var BasedOnCalculation;
(function (BasedOnCalculation) {
  BasedOnCalculation["Headcount"] = "headcount";
  BasedOnCalculation["Fte"] = "fte";
})(BasedOnCalculation || (BasedOnCalculation = {}));
export var useStaffingConfigAPI = function (locationId) {
  return useAPI(STAFFING_API, {
    locationId: locationId !== null && locationId !== void 0 ? locationId : 0
  }, 'GET', {
    key: locationId == null ? 'staffingConfig-none' : "staffingConfig-".concat(locationId)
  });
};
export var useRolesAPI = function (locationId) {
  return useAPI(ROLES_API, {
    locationId: locationId !== null && locationId !== void 0 ? locationId : 0
  }, 'GET', {
    key: locationId == null ? 'roles-none' : "roles-".concat(locationId)
  });
};
export var useCopyRolesFromAPI = function (locationId) {
  return useAPI(ROLES_COPY_FROM_API, {
    locationId: locationId
  }, 'POST', {
    key: "rolesCopyFrom-".concat(locationId)
  });
};
export function saveLocationStaffing(locationId, config) {
  return __awaiter(this, void 0, void 0, function () {
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          return [4 /*yield*/, axios.post(substituteParams(STAFFING_API, {
            locationId: locationId
          }), config, {
            withCredentials: true
          })];
        case 1:
          _a.sent();
          return [2 /*return*/];
      }
    });
  });
}
export function saveLocationRoles(locationId, roles) {
  return __awaiter(this, void 0, void 0, function () {
    var activeRoles, deleteIds;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          activeRoles = roles.filter(function (r) {
            return !r.isDeleted;
          }).map(function (r) {
            var _a;
            return {
              id: (_a = r.id) !== null && _a !== void 0 ? _a : undefined,
              roleName: r.roleName,
              roleType: r.roleType,
              roleAppliesTo: r.roleAppliesTo,
              basedOnCalculation: r.basedOnCalculation,
              isCustom: r.isCustom,
              ratio: r.ratio
            };
          });
          deleteIds = roles.filter(function (r) {
            return r.isDeleted && r.id !== null;
          }).map(function (r) {
            return r.id;
          });
          return [4 /*yield*/, axios.post(substituteParams(ROLES_BATCH_API, {
            locationId: locationId
          }), {
            roles: activeRoles,
            deleteIds: deleteIds
          }, {
            withCredentials: true
          })];
        case 1:
          _a.sent();
          return [2 /*return*/];
      }
    });
  });
}
export var ROLE_TYPE_T_KEYS = (_a = {}, _a[LocationRoleType.Supervisor] = 'roles.types.supervisor', _a[LocationRoleType.QualityAssurance] = 'roles.types.qa', _a[LocationRoleType.Trainer] = 'roles.types.trainer', _a[LocationRoleType.WfmAnalyst] = 'roles.types.wfmAnalyst', _a[LocationRoleType.Recruiter] = 'roles.types.recruiter', _a[LocationRoleType.Custom] = 'roles.types.custom', _a);
export var ROLE_APPLIES_TO_T_KEYS = (_b = {}, _b[RoleAppliesTo.Queue] = 'roles.appliesTo.queue', _b[RoleAppliesTo.Site] = 'roles.appliesTo.site', _b);
export var useStaffingStatusAPI = function (configVersionId) {
  return useAPI("".concat(STAFFING_STATUS_API, "?configVersionId={configVersionId}"), {
    configVersionId: configVersionId !== null && configVersionId !== void 0 ? configVersionId : 0
  }, 'GET', {
    key: "staffingStatus-".concat(configVersionId !== null && configVersionId !== void 0 ? configVersionId : 'none')
  });
};